export var CustomCode;
(function (CustomCode) {
    let CsKindType;
    (function (CsKindType) {
        CsKindType["NameSpace"] = "NameSpace";
        CsKindType["Class"] = "Class";
        CsKindType["Constructor"] = "Constructor";
        CsKindType["Object"] = "Object";
        CsKindType["Variable"] = "Variable";
        CsKindType["PrivateMethod"] = "PrivateMethod";
        CsKindType["ProtectedMethod"] = "ProtectedMethod";
        CsKindType["PublicMethod"] = "PublicMethod";
        CsKindType["InternalMethod"] = "InternalMethod";
        CsKindType["PrivateProperty"] = "PrivateProperty";
        CsKindType["ProtectedProperty"] = "ProtectedProperty";
        CsKindType["PublicProperty"] = "PublicProperty";
        CsKindType["InternalProperty"] = "InternalProperty";
        CsKindType["PrivateField"] = "PrivateField";
        CsKindType["ProtectedField"] = "ProtectedField";
        CsKindType["PublicField"] = "PublicField";
        CsKindType["InternalField"] = "InternalField";
    })(CsKindType = CustomCode.CsKindType || (CustomCode.CsKindType = {}));
    let CompletionItemKind;
    (function (CompletionItemKind) {
        CompletionItemKind[CompletionItemKind["Method"] = 0] = "Method";
        CompletionItemKind[CompletionItemKind["Function"] = 1] = "Function";
        CompletionItemKind[CompletionItemKind["Constructor"] = 2] = "Constructor";
        CompletionItemKind[CompletionItemKind["Field"] = 3] = "Field";
        CompletionItemKind[CompletionItemKind["Variable"] = 4] = "Variable";
        CompletionItemKind[CompletionItemKind["Class"] = 5] = "Class";
        CompletionItemKind[CompletionItemKind["Struct"] = 6] = "Struct";
        CompletionItemKind[CompletionItemKind["Interface"] = 7] = "Interface";
        CompletionItemKind[CompletionItemKind["Module"] = 8] = "Module";
        CompletionItemKind[CompletionItemKind["Property"] = 9] = "Property";
        CompletionItemKind[CompletionItemKind["Event"] = 10] = "Event";
        CompletionItemKind[CompletionItemKind["Operator"] = 11] = "Operator";
        CompletionItemKind[CompletionItemKind["Unit"] = 12] = "Unit";
        CompletionItemKind[CompletionItemKind["Value"] = 13] = "Value";
        CompletionItemKind[CompletionItemKind["Constant"] = 14] = "Constant";
        CompletionItemKind[CompletionItemKind["Enum"] = 15] = "Enum";
        CompletionItemKind[CompletionItemKind["EnumMember"] = 16] = "EnumMember";
        CompletionItemKind[CompletionItemKind["Keyword"] = 17] = "Keyword";
        CompletionItemKind[CompletionItemKind["Text"] = 18] = "Text";
        CompletionItemKind[CompletionItemKind["Color"] = 19] = "Color";
        CompletionItemKind[CompletionItemKind["File"] = 20] = "File";
        CompletionItemKind[CompletionItemKind["Reference"] = 21] = "Reference";
        CompletionItemKind[CompletionItemKind["Customcolor"] = 22] = "Customcolor";
        CompletionItemKind[CompletionItemKind["Folder"] = 23] = "Folder";
        CompletionItemKind[CompletionItemKind["TypeParameter"] = 24] = "TypeParameter";
        CompletionItemKind[CompletionItemKind["User"] = 25] = "User";
        CompletionItemKind[CompletionItemKind["Issue"] = 26] = "Issue";
        CompletionItemKind[CompletionItemKind["Snippet"] = 27] = "Snippet";
    })(CompletionItemKind = CustomCode.CompletionItemKind || (CustomCode.CompletionItemKind = {}));
    let DebugState;
    (function (DebugState) {
        // 调试中
        DebugState[DebugState["Debugging"] = 0] = "Debugging";
        // 异常信息
        DebugState[DebugState["Exceptional"] = 1] = "Exceptional";
        // 结束
        DebugState[DebugState["Finished"] = 2] = "Finished";
    })(DebugState = CustomCode.DebugState || (CustomCode.DebugState = {}));
    let MonitorType;
    (function (MonitorType) {
        MonitorType[MonitorType["CTRLF5"] = 0] = "CTRLF5";
        MonitorType[MonitorType["F5"] = 116] = "F5";
        MonitorType[MonitorType["F6"] = 117] = "F6";
        MonitorType[MonitorType["F9"] = 120] = "F9";
        MonitorType[MonitorType["F10"] = 121] = "F10";
        MonitorType[MonitorType["F11"] = 122] = "F11";
        MonitorType[MonitorType["F12"] = 123] = "F12";
    })(MonitorType = CustomCode.MonitorType || (CustomCode.MonitorType = {}));
    let DebugScene;
    (function (DebugScene) {
        DebugScene["LIST"] = "LIST";
        DebugScene["FORM"] = "FORM";
    })(DebugScene = CustomCode.DebugScene || (CustomCode.DebugScene = {}));
    let DebugSubScene;
    (function (DebugSubScene) {
        /** 调试列表设置请求 */
        DebugSubScene["LIST_SETTING"] = "LIST_SETTING";
        /** 调试列表数据请求 */
        DebugSubScene["LIST_DATA"] = "LIAT_DATA";
    })(DebugSubScene = CustomCode.DebugSubScene || (CustomCode.DebugSubScene = {}));
    /**
     * 任务同步状态
     */
    let TASK_SYNC_STATE;
    (function (TASK_SYNC_STATE) {
        TASK_SYNC_STATE[TASK_SYNC_STATE["unSync"] = 0] = "unSync";
        TASK_SYNC_STATE[TASK_SYNC_STATE["synced"] = 1] = "synced";
    })(TASK_SYNC_STATE = CustomCode.TASK_SYNC_STATE || (CustomCode.TASK_SYNC_STATE = {}));
    /**
     * 按钮任务状态
     */
    let ACTION_TASK_STATE;
    (function (ACTION_TASK_STATE) {
        ACTION_TASK_STATE[ACTION_TASK_STATE["Waiting"] = 0] = "Waiting";
        ACTION_TASK_STATE[ACTION_TASK_STATE["Running"] = 1] = "Running";
        ACTION_TASK_STATE[ACTION_TASK_STATE["Completed"] = 2] = "Completed";
        ACTION_TASK_STATE[ACTION_TASK_STATE["Aborted"] = 3] = "Aborted";
    })(ACTION_TASK_STATE = CustomCode.ACTION_TASK_STATE || (CustomCode.ACTION_TASK_STATE = {}));
    CustomCode.ActionTaskStateMap = {
        [ACTION_TASK_STATE.Waiting]: '待处理',
        [ACTION_TASK_STATE.Running]: '执行中',
        [ACTION_TASK_STATE.Completed]: '已完成',
        [ACTION_TASK_STATE.Aborted]: '已终止',
    };
    /**
     * 数据执行状态
     */
    let ACTION_OBJECT_STATE;
    (function (ACTION_OBJECT_STATE) {
        ACTION_OBJECT_STATE[ACTION_OBJECT_STATE["Unexecuted"] = 0] = "Unexecuted";
        ACTION_OBJECT_STATE[ACTION_OBJECT_STATE["Success"] = 1] = "Success";
        ACTION_OBJECT_STATE[ACTION_OBJECT_STATE["Failed"] = 2] = "Failed";
    })(ACTION_OBJECT_STATE = CustomCode.ACTION_OBJECT_STATE || (CustomCode.ACTION_OBJECT_STATE = {}));
    CustomCode.ActionObjectStateMap = {
        [ACTION_OBJECT_STATE.Unexecuted]: '未执行',
        [ACTION_OBJECT_STATE.Success]: '成功',
        [ACTION_OBJECT_STATE.Failed]: '失败',
    };
    let Request;
    (function (Request) {
        let ICSCodeType;
        (function (ICSCodeType) {
            /** 表单 */
            ICSCodeType[ICSCodeType["Form"] = 1] = "Form";
            /** 列表 */
            ICSCodeType[ICSCodeType["List"] = 2] = "List";
        })(ICSCodeType = Request.ICSCodeType || (Request.ICSCodeType = {}));
    })(Request = CustomCode.Request || (CustomCode.Request = {}));
})(CustomCode || (CustomCode = {}));
